import { useState, useMemo, useCallback } from "react";
import { useDebounce } from "@/hooks/useDebounce";

export const useAccountFilters = () => {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  
  const [view, setView] = useState("table");
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("-createdAt");
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  
  const [filters, setFilters] = useState({
    status: "all",
    activityStatus: "all",
    source: "all",
    city: "all",
    assignedTo: "all",
    serviceType: "all",
    date: "all",
    fromDate: "",
    toDate: ""
  });

  const handleFilterChange = useCallback((key, value) => {
    if (typeof key === 'object') {
      setFilters(prev => ({ ...prev, ...key }));
    } else {
      setFilters(prev => ({ ...prev, [key]: value }));
    }
    setPage(1);
  }, []);

  return {
    search, setSearch,
    debouncedSearch,
    view, setView,
    page, setPage,
    sortBy, setSortBy,
    filters, 
    setFilters: handleFilterChange,
    showAdvancedFilters, setShowAdvancedFilters
  };
};




